
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Flag, Loader2 } from "lucide-react";
import { useState } from "react";

interface ReportDialogProps {
  onReport: (reason: string) => Promise<void>;
}

export const ReportDialog = ({ onReport }: ReportDialogProps) => {
  const [reportReason, setReportReason] = useState("");
  const [isReporting, setIsReporting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleReport = async () => {
    setIsReporting(true);
    try {
      await onReport(reportReason);
      setDialogOpen(false);
      setReportReason("");
    } finally {
      setIsReporting(false);
    }
  };

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1 h-8">
          <Flag className="h-4 w-4" />
          <span>Report</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Report Review</DialogTitle>
          <DialogDescription>
            Please provide a reason for reporting this review. This will be reviewed by our moderators.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder="Enter your reason for reporting..."
          value={reportReason}
          onChange={(e) => setReportReason(e.target.value)}
          className="min-h-[100px]"
        />
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setDialogOpen(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReport}
            disabled={isReporting}
          >
            {isReporting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Reporting...
              </>
            ) : (
              'Submit Report'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
